import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  controls: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    margin: theme.spacing(2, 0)
  },
  periodSelect: { minWidth: 200 },
  windowNote: { color: theme.palette.text.secondary },
  retentionNote: {
    color: theme.palette.text.secondary,
    margin: theme.spacing(1, 0)
  },
  error: { margin: theme.spacing(2, 0) },
  section: { margin: theme.spacing(3, 0) },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2, 0)
  },
  /**
   * Visually hidden, still announced. Not `display: none`, which removes it from the
   * accessibility tree along with the screen — the announcement has to reach a reader while
   * staying out of the sighted layout.
   */
  announcement: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap'
  },
  /*
    THE TABLES HAD NO LAYOUT AT ALL until the pre-merge gate said so. The role="row" and
    role="cell" divs carried no class, and JSX strips whitespace-only text nodes across a
    newline, so a row rendered as "The budget is used up12" — label and count glued, columns
    unaligned. Every test passed: they query by role and text, so getByText('4') finds the
    count whether or not anything separates it from the label.

    The screen reader was getting a correct table while the sighted operator got run-on text,
    which is the inverse of the usual failure and the reason no amount of ARIA review would
    have caught it.

    Grid rather than display:table, matching OverviewTable — explicit ARIA roles survive
    display:grid, where native table semantics do not.
  */
  tableHead: {
    display: 'grid',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    color: theme.palette.text.secondary
  },
  tableRow: {
    display: 'grid',
    gap: theme.spacing(1),
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    marginBottom: theme.spacing(0.5)
  },
  /*
    Two columns for the reason summary, three once a promotion name is in front — plus a
    trailing action column in each, which holds the refresh IconButton in the header row and
    nothing in the data rows.
    ONE constant per table, referenced by both the head and the row rules, so the two cannot
    drift. `portal-ux-conventions.md` §2 asks for exactly this and notes that its own
    ChannelsList reference fails to do it.
  */
  reasonColumns: { gridTemplateColumns: '1fr auto 40px' },
  promotionColumns: { gridTemplateColumns: '2fr 3fr auto 40px' },
  /* Keeps the header's refresh button from stretching the row height. */
  refresh: { justifySelf: 'end', padding: 4 },
  /*
    A reason label is a SENTENCE, not a word, so it must wrap rather than truncate — a
    truncated reason is a wrong reason. `anywhere` matches the sibling's treatment of long
    promotion names.
  */
  label: { overflowWrap: 'anywhere' },
  /* `end` is LOGICAL: correct in both directions without depending on the RTL flipper. */
  numeric: { textAlign: 'end' as const, fontVariantNumeric: 'tabular-nums' },
  caption: {
    padding: theme.spacing(2, 2, 1),
    fontWeight: 600
  },
  caveat: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(1, 2, 2),
    display: 'block'
  },
  unattributed: { color: theme.palette.text.secondary }
}))

export default useStyles
